<div class="pagecontent">
    <form [formGroup]="preTripRequestForm">
        <mat-horizontal-stepper [selectedIndex]="activeStepperIndex" animationDuration="0ms" #stepper >
            <mat-step>
                <ng-template matStepLabel>Appointment Date</ng-template>
                <app-appointment [tripType]="'Pre'"></app-appointment>
                <div class="appointment-button">
                    <button type="button"  mat-button (click)="goToTripLocation(stepper, 'Next')">Next</button>
                </div>               
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Trip Location</ng-template>
                <app-trip-location></app-trip-location>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToAppointment(stepper)">Back</button></div>
                    <div class="right-button">
                        <button type="button"   mat-button (click)="goToSummary(stepper, 'Next')">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Summary</ng-template>
                <app-trip-summary [tripType]="'Pre'"></app-trip-summary>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToTripLocation(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="submit"   mat-button (click)="saveTripSumary()">Submit</button>
                    </div>                   
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </form>
</div>

<ng-template #confirmationDialogTemplate>
  <div class="access-dialogue">
    <div mat-dialog-title class="dialog-title-center">
        <span>{{dialogTitle}}</span>
    </div>
    <mat-dialog-content>
      <p>{{dialogContent}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions-center">
      <button mat-flat-button color="primary" (click)="closeDialog()" aria-label="Continue to next step">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>